export default __webpack_public_path__ + "static/media/interaktiven-dizajn.698c8075.gif";